import { AutoGenerateWorkQueuesCommand, WorkQueueDto } from '@operations/app/api'
import { workQueueService } from '@operations/services/workQueueService'
import { SaveWorkQueueCommand } from './../app/api'
import { BaseEntityStore } from './base/BaseEntityStore'

export class WorkQueueStore extends BaseEntityStore<WorkQueueDto> {
  async updateWorkQueueName(id: number, workQueueName: string | null | undefined) {
    await workQueueService.rename(id, workQueueName)
  }

  async load(vesselVisitId: number) {
    const data = await workQueueService.load(vesselVisitId)

    this.updateStoreItems(data)
  }

  async autoGenerateWorkQueues(autoGenerateWorkQueues: AutoGenerateWorkQueuesCommand) {
    await workQueueService.autoGenerateWorkQueues(autoGenerateWorkQueues)
  }

  async saveCraneSplit(saveWorkQueueCommand: SaveWorkQueueCommand) {
    const data = await workQueueService.saveCraneSplit(saveWorkQueueCommand)

    return data
  }

  async startWorkQueue(workQueueId: number) {
    const data = await workQueueService.startWorkQueue(workQueueId)

    this.updateStoreItem(data, workQueueId)
  }

  async stopWorkQueue(workQueueId: number) {
    const data = await workQueueService.stopWorkQueue(workQueueId)

    this.updateStoreItem(data, workQueueId)
  }
}
